module.exports = {"available":"Wolne","booked":"Zarezerwowane","occupied":"Zajęte","booked-occupied":"Zarezerwowane / Zajęte","used":"używany","until":"do","all-day":"Wszystkie dni","page_over_total":"Strona {page} z {total}","room-name":"Nazwa pokoju","current-booking":"Aktualnie","next-booking":"Następne","unknown":"Nieznany","floors":"Piętro","today":"Dzisiaj","no_bookings":"Brak zaplanowanych spotkań.","no_information":"Brak informacji.","description":"Opis","capacity":"Pojemność","allocated":"Przydzielone","booked-occupied-allocated":"Zarezerwowane / Zajęte / Przydzielone"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/pl.json
// module id = keC1
// module chunks = 2